import React from 'react';

import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';

function NoManagerInfoCopy() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <WarningIcon className={classes.warning} />
      <Typography>
        No valid manager column was detected in your file. In order to create your org chart, you
        need to correctly set up a column that properly references a person’s manager. Use “+ Upload
        a New CSV” in the Mappings Summary to make changes to your data. For more information on
        setting up this column, click{' '}
        <Link
          color="secondary"
          href="http://help.justsift.com/en/articles/9584913-adding-a-manager-column-to-your-csv"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </Link>
        .
      </Typography>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(3),
    display: 'flex',
  },
  warning: {
    color: theme.palette.warning.main,
    marginRight: theme.spacing(),
  },
}));

export default NoManagerInfoCopy;
